import utilsApi from '../assets/js/utils';
export default utilsApi.creatApi({
    // 获取商城商品信息
    getShopGoodsList: ["post", "getShopGoodsList"],
    // 获取商品分类信息
    getShopGoodsCatalogs: ["post", "getShopGoodsCatalogs"],
    // 获取头像框数据
    getAvatarBoxList: ['get', 'https://router.gamersky.com/@/userData/asset/shop/avatarBoxList?status=1'],
    // 获取用户头像
    getUserHeadImg: ['post', 'https://router.gamersky.com/@/userData/asset/getUserAvatarBoxList'],
    // 购买头像框
    buyAvatarBox: ['post','https://router.gamersky.com/@/userData/asset/buyAvatarBox'],
});